<template>
	<Menu v-slot="{ close }" as="div" class="relative">
		<MenuButton class="pr-2 pt-2">
			<span class="sr-only">Åbn brugermenu</span>
			<span class="lg:flex lg:items-center">
				<MenuIcon class="icon-gray icon-large fill-gray-400" />
			</span>
		</MenuButton>
		<Transition
			enter-active-class="transition ease-out duration-100"
			enter-from-class="transform opacity-0 scale-95"
			enter-to-class="transform opacity-100 scale-100"
			leave-active-class="transition ease-in duration-75"
			leave-from-class="transform opacity-100 scale-100"
			leave-to-class="transform opacity-0 scale-95"
		>
			<MenuItems
				class="absolute right-0 z-20 mt-5 w-48 origin-top-right rounded-3xl overflow-hidden bg-white dark:bg-[#2A294B] divide-y divide-[#E9EEF6] dark:divide-[#666597] border border-[#E9EEF6] dark:border-[#666597] focus:outline-none text-base md:text-lg font-medium text-[#B0B7C8]"
				@click="close"
			>
				<MenuItem v-slot="{ active }">
					<RouterLink :to="{ name: 'search' }">
						<button
							type="button"
							class="p-4 flex items-center"
							:class="[active ? 'text-[#0095FF]' : '']"
						>
							<SearchIcon
								class="size-6 mr-2 icon-blue-soft"
								aria-hidden="true"
							/>
							Søg
						</button>
					</RouterLink>
				</MenuItem>

				<div class="border-t border-[#E9EEF6] dark:border-[#666597]" aria-hidden="true"></div>

				<MenuItem v-slot="{ active }">
					<RouterLink :to="{ name: 'entry-lists' }">
						<button
							type="button"
							class="p-4 flex items-center"
							:class="[active ? 'text-[#0095FF]' : '']"
						>
							<FavoritesIcon
								class="size-6 mr-2 icon-yellow"
								aria-hidden="true"
							/>
							Ordlister
						</button>
					</RouterLink>
				</MenuItem>

				<div class="border-t border-[#E9EEF6] dark:border-[#666597]" aria-hidden="true"></div>

				<MenuItem v-slot="{ active }">
					<RouterLink :to="{ name: 'flashcards' }">
						<button
							type="button"
							class="p-4 flex items-center"
							:class="[active ? 'text-[#0095FF]' : '']"
						>
							<FlashcardsIcon
								class="size-6 mr-2 icon-green-soft"
								aria-hidden="true"
							/>
							Flashcards
						</button>
					</RouterLink>
				</MenuItem>

				<div class="border-t border-[#E9EEF6] dark:border-[#666597]" aria-hidden="true"></div>

				<MenuItem v-slot="{ active }">
					<RouterLink :to="{ name: 'search-history' }">
						<button
							type="button"
							class="p-4 flex items-center"
							:class="[active ? 'text-[#0095FF]' : '']"
						>
							<SearchhistoryIcon
								class="size-6 mr-2 icon-purple-soft"
								aria-hidden="true"
							/>
							Søgehistorik
						</button>
					</RouterLink>
				</MenuItem>

				<MenuItem v-slot="{ active }">
					<button
						type="button"
						class="p-4 flex items-center"
						:class="[active ? 'text-[#0095FF]' : '']"
						@click="settingsModalOpen = true"
					>
						<SettingsIcon class="size-6 mr-2 icon-gray" aria-hidden="true" />
						Indstillinger
					</button>
				</MenuItem>

				<MenuItem v-slot="{ active }">
					<button
						type="button"
						class="p-4 w-full text-left flex items-center"
						:class="[active ? 'text-[#0095FF]' : '']"
						@click="confirmOpen = true"
					>
						<LogOutIcon
							class="size-6 mr-2 icon-red-soft dark:fill-transparent fill-transparent"
							aria-hidden="true"
						/>
						Log ud
					</button>
				</MenuItem>
			</MenuItems>
		</Transition>
		<ConfirmModal
			:open="confirmOpen"
			message="Er du sikker på du vil logge ud?"
			accept-text="Log ud"
			title="Bekræft log ud"
			:danger="true"
			@confirm="onClickLogout"
			@cancel="confirmOpen = false"
			@close="confirmOpen = false"
		/>
	</Menu>

	<SettingsModal :open="settingsModalOpen" @close="settingsModalOpen = false" />
</template>

<script setup lang="ts">
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue';
import { ref } from 'vue';
import { useRouter } from 'vue-router';

import LogOutIcon from '@/assets/icons/coco/bold/Turn off.svg?component';
import SearchhistoryIcon from '@/assets/icons/coco/duotone/Message - 3.svg?component';
import SearchIcon from '@/assets/icons/coco/duotone/Search.svg?component';
import SettingsIcon from '@/assets/icons/coco/duotone/Setting.svg?component';
import FavoritesIcon from '@/assets/icons/coco/duotone/Star.svg?component';
import MenuIcon from '@/assets/icons/coco/line/More-1.svg?component';
import FlashcardsIcon from '@/assets/icons/custom/flashcard-1.svg?component';
import ConfirmModal from '@/components/ui/modals/ConfirmModal.vue';
import { useUserStore } from '@/stores/user';

import SettingsModal from './modals/SettingsModal.vue';

const router = useRouter();
const userStore = useUserStore();

const confirmOpen = ref(false);
const settingsModalOpen = ref(false);

function onClickLogout() {
	userStore.logout().then(() => {
		router.push({ name: 'home' });
	});
}
</script>

<style>
.avatar-container {
	display: flex;
	width: 100%;
	overflow: hidden;
	border-bottom-left-radius: calc(3.5rem / 2);
	border-bottom-right-radius: calc(3.5rem / 2);
}
.avatar-container .background-color {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 3rem;
	height: 3rem;
	border-radius: 50%;
}
.avatar-container img {
	width: 3rem;
	height: auto;
}
</style>
